<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="people-outline" pack="eva" [ngStyle]="{color: tenant?.color}"></nb-icon>
  <div class="description">
    <div class="title">
      {{tenant?.name}}
    </div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>

